import React from "react";
import { RichText as PrismicRichText } from "prismic-dom";
import { Box, Flex } from "rebass";

import { Article, H2, PageSection } from "components";

let linkResolver = function (doc) {
  return "/" + doc.type;
};

export const RichText = (props) => {
  return (
    <PageSection column="true" borderTop="true">
      <Flex
        is="section"
        flexDirection={["column", null, "row"]}
        mt={[5, 6]}
        mb={[5, 6]}
      >
        <Box
          w={[1, null, 1 / 2]}
          mb={[5, null, 0]}
          mr={[0, null, 4]}
          pr={[0, null, 4]}
        >
          {props.primary.title && props.primary.title[0] && (
            <H2 children={props.primary.title[0].text} color="violet" />
          )}
        </Box>
        <Box
          w={[1, null, 1 / 2]}
          mb={[5, null, 0]}
          mr={[0, null, 4]}
          pr={[0, null, 4]}
        >
          {props.primary.content && props.primary.content[0] && (
            <Article
              dangerouslySetInnerHTML={{
                __html: PrismicRichText.asHtml(
                  props.primary.content,
                  linkResolver
                ),
              }}
            />
          )}
        </Box>
      </Flex>
    </PageSection>
  );
};



// WEBPACK FOOTER //
// ./src/slices/RichText/RichText.js